import { render, staticRenderFns } from "./ButtonMovie.vue?vue&type=template&id=3268248f&scoped=true&"
import script from "./ButtonMovie.vue?vue&type=script&lang=ts&"
export * from "./ButtonMovie.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonMovie.vue?vue&type=style&index=0&id=3268248f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3268248f",
  null
  
)

export default component.exports